import { CartItem } from './cart-item.model';

export class ValidatedCart {
  validatedCart: CartItem[] = [];
  containsError: boolean = false;
  containsWarning: boolean = false;
}
